export default __webpack_public_path__ + "static/media/nu.dbff3333.svg";